// --------------------------------------------------------------
// Created On: 2024-10-08
// Author: KC Willard
//
// Last Modified: 2024-10-11
// Modified By: KC Willard
//
// Copyright 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Returns whether the string conforms to the format of an integer. No letters are allowed
// and no decimal points are allowed. This should be used for text input validation only.
export default function stringIsInteger(input: string): boolean {
  const pattern = new RegExp("^[0-9]*$");
  return pattern.test(input);
}
